import logo72x72 from "./logo72x72.png";
import logo96x96 from "./logo72x72.png";
import logo120x120 from "./logo120x120.png";
import logo1024x1024 from "./logo1024x1024.png";
import intro from "./intro.jpg";
import bg from "./bg.jpg";

export default {
    logo72x72,
    logo96x96,
    logo120x120,
    logo1024x1024,
    intro,
    bg
}